<template>
  <div id="app">
    <meHeader />
    <router-view v-slot="{ Component }">
        <transition enter-active-class="animate__animated animate__slideInLeft" leave-active-class="animate__animated ">
        <component :is="Component" v-if="loadOver" />
      </transition>
    </router-view>
    <meFooter />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "App",
  computed: mapGetters(["loadOver"]),
};
</script>

<style lang='less'>

@import url("./assets/iconfont.css");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.rich-articel {
  width: 77.7vw;
  background: #fff;
  margin: 0px auto 1vw;
  padding: 2.08vw;
}
input {
  outline: none;
}
// 表格内容居中显示
// .el-table td,
// .el-table th {
//   text-align: center !important;
// }
.main {
  max-width: 77.7vw;
  margin: 0 auto;
  padding: 4.16vw 0 3.125vw;
  > h1 {
    margin-bottom: 3.1vw;
  }
}
.bgimg {
  width: 100%;
  height: 29.84vw;
}
div {
  background-size: 100% 100%;
}
a {
  text-decoration: none;
  color: #333;
}
h1 {
  font-size: 1vw;
  font-weight: bold;
}
#app {
  background: #fffdfd;
  position: relative;
  padding-bottom: 26.35vw;
  font-family: "PingFang SC Bold";
  min-height: 100vh;
}
.container {
  max-width: 77.7vw;
  margin: 0 auto;
}
@import url("./assets/common.css");
</style>
 


// WEBPACK FOOTER //
// src/App.vue